import { __assign } from "tslib";
import { camelCaseKeys } from '@tencent/docs-scenario-component-tools';
export function getPrivilegeAttributesByBasicClientVars(basicClientVars) {
    var _a, _b;
    return __assign(__assign({}, (_a = basicClientVars.authInfo) === null || _a === void 0 ? void 0 : _a.attribute), { 
        // FIXME: @mingqiuliao 这里不应该破坏原本的类型
        isPrivilegeExpired: !!((_b = basicClientVars.authInfo) === null || _b === void 0 ? void 0 : _b.privilegeExpire) });
}
/**
 * @deprecated 兼容旧版本逻辑，生成 DocPrivilege 实例
 * @param clientVars 旧版本 clientVars
 * @returns DocPrivilege 实例
 */
export function getPrivilegeAttributesByClientVars(clientVars) {
    return __assign({}, camelCaseKeys(clientVars.privilegeAttribute));
}
